export default {
  en: {    
  	chat: {
      search: 'Search in messages...',
      notfound: 'No conversations found',
      select: 'Select a conversation',
      type: 'Type a message...',
      notfounddisclaimer: 'You have no conversations yet, go to search to place an offer on shipment so you can chat with the sender when he/she accepts your offer.',
  	}
  },
  nl: {    
  	chat: {
  		search: 'Zoeken in berichten...',
      notfound: 'Geen gesprekken gevonden',
      select: 'Selecteer een gesprek',
      type: 'Type een chatbericht...',
      notfounddisclaimer: 'Je hebt nog geen gesprekken, ga naar zoeken om een bod te plaatsen op een zending. Eens de verzender je bod aanvaardt kan je met hem/haar chatten.',
  	}
  },
  fr: {    
  	chat: {
  		search: 'Rechercher dans les messages ...',
      notfound: 'Aucune conversation trouvée',
      select: 'Sélectionnez une conversation',
      type: 'Écrire un message...',
      notfounddisclaimer: 'Vous n\'avez pas encore de conversation, allez à la recherche pour placer une offre lors de l\'expédition afin de pouvoir discuter avec l\'expéditeur lorsqu\'il accepte votre offre.'
  	}  	
  }
}
